import {ResourceParams, resources} from "../../../../models/resource/resources";
import {
  AdvertisementStatisticsAccordion,
  AdvertisementStatisticsFormField
} from "../types/advertisement-statistics-modal.types";
import {FilesViewerData, FileTypeName} from "../../../../types/file.types";
import {FilesStatus} from "../../../../types/files-status.types";
import {defaultFilesStatus} from "../../../../models/default-file-params";

export const advertisementStatisticsResourceType: ResourceParams = resources['advertisement-statistics'];

export const advertisementStatisticFileButtons: Array<AdvertisementStatisticsFormField> = [
  {
    label: 'Первичное видео',
    fieldName: 'initialVideoFileId',
    statusName: 'initialVideoStatus',
    key: 'INITIAL_VIDEO'
  },
  {
    label: 'Финальное видео',
    fieldName: 'finalVideoFileId',
    statusName: 'finalVideoStatus',
    key: 'FINAL_VIDEO'
  },
  {
    label: 'Пост статистика от блогера',
    fieldName: 'postStatisticsFileId',
    statusName: 'postStatisticsStatus',
    key: 'POST_STATISTICS'
  },
]

export const advertisementStatisticsFormFields: Array<AdvertisementStatisticsFormField> = [
  {
    label: 'Ссылка на рекламу',
    fieldName: 'advertisementLink',
    statusName: 'advertisementLinkStatus'
  },
  {
    label: 'Первичное видео (ссылка)',
    fieldName: 'initialVideoLink',
    type: 'text',
    accordionName: 'old-format'
  },
  {
    label: 'Финальное видео (ссылка)',
    fieldName: 'finalVideoLink',
    type: 'text',
    accordionName: 'old-format'
  },
  {
    label: 'Пост статистика от блогера (ссылка)',
    fieldName: 'postStatisticsLink',
    type: 'text',
    accordionName: 'old-format'
  },
  {
    label: 'Оценка видео',
    fieldName: 'videoScore',
    type: 'select',
    accordionName: 'video-rating'
  },
  {
    label: 'Тип ролика',
    fieldName: 'videoTypeId',
    type: 'select',
    accordionName: 'video-rating'
  },
  {
    label: 'Контент для распространения',
    fieldName: 'contentForDistributionType',
    type: 'select',
    accordionName: 'video-rating'
  },
  {
    label: 'Комментарий оценщика',
    fieldName: 'videoFeedback',
    type: 'textarea',
    accordionName: 'video-rating'
  },
  {
    label: 'История',
    fieldName: 'history',
    type: 'button',
    accordionName: 'video-rating'
  }
];

export const statisticsFileIdKeys: Array<FileTypeName> = [
  'INITIAL_VIDEO', 'FINAL_VIDEO', 'POST_STATISTICS'
];

export const statisticsButtons: Array<FilesViewerData> = [
  {
    title: 'Первичное видео',
    key: 'INITIAL_VIDEO'
  },
  {
    title: 'Финальное видео',
    key: 'FINAL_VIDEO'
  },
  {
    title: 'Пост статистика от блогера',
    key: 'POST_STATISTICS'
  }
];

export const defaultAdvertisementStatisticsFilesStatus: FilesStatus = {
  ...defaultFilesStatus,
  initialVideoStatus: 'ERROR',
  finalVideoStatus: 'ERROR',
  postStatisticsStatus: 'ERROR',
  advertisementInitialStatisticsStatus: 'ERROR',
  advertisementLinkStatus: 'ERROR'
}

export const advertisementStatisticsAccordions: Array<AdvertisementStatisticsAccordion> = [
  {
    name: 'old-format',
    label: 'Старый формат'
  },
  {
    name: 'video-rating',
    label: 'Оценка видео'
  }
]
